export default "__VITE_ASSET__De772VlE__"